<template>
  <header class="site-header">
    <div class="logo-container">
      <img src="../assets/logo2.jpg" alt="Dr. Mayo Lee Logo" class="logo">
    </div>
    <div class="header-text">Dr. Mayo Lee | Psoriasis Treatment Center</div>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
.site-header {
  padding: 20px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-container {
  margin-right: 20px;
}

.logo {
  height: 60px;
  width: auto;
}

.header-text {
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
</style>
